import { Action } from '@ngrx/store';
import { SystemPermissionModel } from '../../models/SystemPermissionModel';

export const REMOVE_PERMISSION_TO_ROLE_SUCCESS = '[Security] Remove Add Permission Success';

export class RemovePermissionToRoleSuccessAction implements Action {
  readonly type = REMOVE_PERMISSION_TO_ROLE_SUCCESS;

  constructor(public payload: { roleKey: string, permission: SystemPermissionModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/RemovePermissionToRoleSuccessAction.ts